import React, { useState, useEffect, useCallback, useRef } from 'react';
// import axios from 'axios';
import axios from '../../hooks/fetchWithAuth';
import "../../App.css";
import "../../index.css";
import { Span, Div, Flex } from "../../style";
import { Button, Paper } from "@mui/material";
import Avatar from '@mui/material/Avatar';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ReactQuill from 'react-quill';
import ConfirmationDialog from '../Confirmation';
import '@react-pdf-viewer/core/lib/styles/index.css';
import config from '../../config';
import getCookie from '../../hooks/getCookie';
import CryptoJS from 'crypto-js';
import './style.css';
import { getAvatarUrl } from '../../utils/getAvatarUrl';
import MentionTextArea from '../MentionTextArea';

function Comments({ comments1, fetchTiBoardData, selectedCard }) {
    const backendIp = config.backend_ip;
    const [editedCommentText, setEditedCommentText] = useState('');
    const [commentToDelete, setCommentToDelete] = useState(null);
    const [dialogOpenComments, setDialogOpenComments] = useState(false);
    const [editingCommentId, setEditingCommentId] = useState(null);
    const [comments, setComments] = useState([]);
    const nameComplete = getCookie("nome_completo");
    const username = getCookie("username");
    const session_id = getCookie("session_id");

    useEffect(() => {
        setComments(comments1);
    });

    const handleUpdateComment = async () => {
        let cleanedValue = editedCommentText
            .replace(/<\/p><p>/g, '\n')
            .replace(/^<p>/, '')
            .replace(/<\/p>$/, '')
            .trim();
        // Remove <span class="ql-mention" ...>@username</span> => @username
        cleanedValue = cleanedValue.replace(/<span class="ql-mention"[^>]*data-value="([^"]+)"[^>]*>[^<]*<\/span>/g, '@$1');

        if (cleanedValue !== '') {
            try {
                const response = await axios.put(`${backendIp}/api/board/ti/update_comment`, {
                    comment_id: editingCommentId,
                    comment_text: cleanedValue,
                    username: username,
                    session_id: session_id
                })

                setEditingCommentId(null);
                setEditedCommentText('');

                fetchTiBoardData(selectedCard);

            } catch (error) {
                return null;
            }
        }
    }

    const handleDeleteComments = async (commentId) => {
        try {
            const response = await axios.put(`${backendIp}/api/board/ti/remove_comment`, {
                comment_id: commentId,
                username: username,
                session_id: session_id
            });

            const comment_removed = response.data;
            setComments(comments.filter(comments => comments.comment_id !== commentId));

            setDialogOpenComments(false);
            fetchTiBoardData(selectedCard);

            return comment_removed;
        } catch (error) {
            return [];
        }
    }

    const handleCancelClick = () => {
        setEditingCommentId(null);
        setEditedCommentText('');
    };

    const renderMentions = (text) => {
        // Converte @usuario em spans destacados
        return text.replace(/@(\w+)/g, '<span class="mention-display">@$1</span>');
    };

    const convertNewlinesToBr = (text) => text.replace(/\n/g, '<br/>');

    const handleEditClick = (commentId, commentText) => {
        setEditingCommentId(commentId);
        setEditedCommentText(commentText);
    };

    const modules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' },
            { 'indent': '-1' }, { 'indent': '+1' }],
            ['image'],
        ],
    };

    const updateOldImageUrls = (url) => {
        const oldUrlPattern = /^https:\/\/lesteboard\.lestetelecom\.com\.br\/api\/board\/ti\/get_image\//;
        if (oldUrlPattern.test(url)) {
            return url.replace('https://lesteboard.lestetelecom.com.br/', 'https://lesteboard.lestetelecom.com.br:4443/');
        }
        return url;
    };

    const replaceImgWithClickableSpan = (html) => {
        return html.replace(/<img\b[^>]*src=["']([^"']+)["'][^>]*>/gi, (match, p1) => {
            const updatedUrl = updateOldImageUrls(p1);
            return `<span class="clickable-image-wrapper" style="cursor:pointer;" data-src="${updatedUrl}"><img src="${updatedUrl}" /></span>`;
        });
    };

    const convertUrlsToLinks = (text) => {
        const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
        return text.replace(urlPattern, (url) => {
            // Ignore URLs inside img tags
            if (text.includes(`<img src="${url}"`)) {
                return url;
            }
            return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
        });
    };

    return comments.map(comment => {
        const containsImgTag = /<img\b[^>]*>/i.test(comment.comment_text);
        
        // Processa menções e imagens
        let processedText = renderMentions(comment.comment_text);
        processedText = replaceImgWithClickableSpan(processedText);

        return (
            <Div className='comment' key={comment.comment_id}>
                <Flex>
                    <Avatar className='comment-avatar' src={getAvatarUrl(comment.created_by)} />
                    <div>
                        <Flex>
                            <Span className='user-comments'>{comment.comment_created_by_name}</Span>
                            <Span className='comment-timestamp'>{comment.comment_created_at}</Span>
                        </Flex>
                        {editingCommentId === comment.comment_id ? (
                            <div>
                                <MentionTextArea
                                    value={convertNewlinesToBr(editedCommentText)}
                                    onChange={setEditedCommentText}
                                    placeholder="Editar comentário..."
                                    selectedCard={selectedCard}
                                />
                                <Button onClick={handleUpdateComment} className='comment-cancel'>Salvar</Button>
                                <Button onClick={handleCancelClick} className='comment-cancel'>Cancelar</Button>
                            </div>
                        ) : (
                            <Paper className='paper-comments' style={{ padding: 10, wordWrap: 'break-word', whiteSpace: 'pre-line', boxSizing: 'border-box', overflowWrap: 'break-word', overflowBlock: 'auto' }}>
                                <div className='comment-content' dangerouslySetInnerHTML={{ __html: convertUrlsToLinks(processedText) }} />
                            </Paper>
                        )}
                        {editingCommentId !== comment.comment_id && nameComplete === comment.comment_created_by_name && (
                            <div style={{ display: 'flex' }}>
                                <Button className='edit-button' onClick={() => handleEditClick(comment.comment_id, comment.comment_text)}>
                                    <EditIcon style={{ fontSize: '0.7rem' }} />Editar
                                </Button>
                                <Button className='delete-button' onClick={() => {
                                    setCommentToDelete(comment.comment_id);
                                    setDialogOpenComments(true);
                                }}>
                                    <DeleteIcon style={{ fontSize: '0.7rem' }} />Excluir
                                </Button>
                                <ConfirmationDialog
                                    open={dialogOpenComments}
                                    onClose={() => setDialogOpenComments(false)}
                                    onConfirm={() => {
                                        handleDeleteComments(commentToDelete);
                                        setCommentToDelete(null);
                                    }}
                                    title="Confirmar Exclusão"
                                    message="Tem certeza de que deseja excluir o comentário? Esta ação não pode ser desfeita."
                                />
                            </div>
                        )}
                    </div>
                </Flex>
            </Div>
        );
    });
}

export default Comments;